import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ThemeContext } from "context/ThemeContext";
import { useWhiteLabel } from "context/WhiteLabelContext";
import { getTipoUsuario } from "store/selectors/AuthSelectors";
import GenericLogo from "jsx/components/CitoPlus/components/GenericLogo";

import logoDefault from "images/logos_citoplus_only_logo.png";
import logoOnlyTextDefault from "images/logos_citoplus_only_text.png";
import logoBlancoDefault from "images/logos_citoplus_only_logo_blanco.png";
import logoBlancoOnlyTextDefault from "images/logos_citoplus_only_text_blanco.png";

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const { navigationHader, background } = useContext(ThemeContext);
  const tipoUsuario = useSelector(getTipoUsuario);
  const {
    isWhiteLabel,
    brandName,
    logo: customLogo,
    logoWhite: customLogoWhite,
  } = useWhiteLabel();

  const getDashboardUrl = () => {
    if (tipoUsuario === "RESIDENTE") {
      return "/dashboard-residente";
    }
    return "/dashboard";
  };

  const isDarkMode =
    background.value === "dark" || navigationHader !== "color_1";

  const renderLogo = () => {
    // Si es marca blanca sin logo personalizado, usar logo genérico + brandName
    if (isWhiteLabel && !customLogo && !customLogoWhite) {
      return (
        <>
          <GenericLogo
            width={50}
            height={50}
            dark={isDarkMode}
            className="logo-abbr"
          />
          {brandName && (
            <span
              className="brand-title"
              style={{
                fontSize: "18px",
                fontWeight: "700",
                color: isDarkMode ? "#FFFFFF" : "#0d2c54",
                marginLeft: "8px",
                whiteSpace: "nowrap",
                letterSpacing: "0.5px",
              }}
            >
              {brandName}
            </span>
          )}
        </>
      );
    }

    // Si es marca blanca con logo personalizado
    if (isWhiteLabel) {
      const logoToUse = isDarkMode ? customLogoWhite || customLogo : customLogo;
      return (
        <>
          <img src={logoToUse} alt="" width={"90%"} className="logo-abbr" />
          {brandName && (
            <span
              className="brand-title"
              style={{
                fontSize: "18px",
                fontWeight: "700",
                color: isDarkMode ? "#FFFFFF" : "#0d2c54",
                marginLeft: "8px",
                whiteSpace: "nowrap",
                letterSpacing: "0.5px",
              }}
            >
              {brandName}
            </span>
          )}
        </>
      );
    }

    // Logo de CitoPlus (no es marca blanca)
    const logoToUse = isDarkMode ? logoBlancoDefault : logoDefault;
    const logoTextToUse = isDarkMode
      ? logoBlancoOnlyTextDefault
      : logoOnlyTextDefault;

    return (
      <>
        <img src={logoToUse} alt="" width={"90%"} className="logo-abbr" />
        <img src={logoTextToUse} alt="" width={"90%"} className="brand-title" />
      </>
    );
  };

  return (
    <div className="nav-header">
      <Link to={getDashboardUrl()} className="brand-logo">
        {renderLogo()}
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          NavMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
